import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useEffect, useState } from 'react';
import { debounce } from '@outdoor-voices/ui';
import { isMobileLarge, isMobileMedium, isTabletSmall, isTwoColumn } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import { Provider } from 'urql';
import { RESIZE } from '@outdoor-voices/ui/dist/config/constants';
import PropTypes from 'prop-types';
import graphqlClient from './graphqlClient';
import { jsx as _jsx } from "react/jsx-runtime";
export var OVContext = /*#__PURE__*/createContext({
  mobileLarge: false,
  mobileMedium: false,
  tabletSmall: false,
  twoColumn: false
});
export var OVContextProvider = function OVContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(isMobileLarge()),
      _useState2 = _slicedToArray(_useState, 2),
      mobileLarge = _useState2[0],
      setIsMobileLarge = _useState2[1];

  var _useState3 = useState(isMobileMedium()),
      _useState4 = _slicedToArray(_useState3, 2),
      mobileMedium = _useState4[0],
      setIsMobileMedium = _useState4[1];

  var _useState5 = useState(isTabletSmall()),
      _useState6 = _slicedToArray(_useState5, 2),
      tabletSmall = _useState6[0],
      setIsTabletSmall = _useState6[1];

  var _useState7 = useState(isTwoColumn()),
      _useState8 = _slicedToArray(_useState7, 2),
      twoColumn = _useState8[0],
      setIsTwoColumn = _useState8[1]; // Change the isMobile state based on the width of the browser


  useEffect(function () {
    var onResize = function onResize() {
      setIsMobileMedium(isMobileMedium());
      setIsMobileLarge(isMobileLarge());
      setIsTabletSmall(isTabletSmall());
      setIsTwoColumn(isTwoColumn());
    }; // Debounce the listener, so we don't re-render too much


    var debouncedResize = debounce(onResize, 150);
    window.addEventListener(RESIZE, debouncedResize); // Remove the listener for cleanup on re-render

    return function () {
      window.removeEventListener(RESIZE, debouncedResize);
    };
  }, []);
  return /*#__PURE__*/_jsx(OVContext.Provider, {
    value: {
      mobileLarge: mobileLarge,
      mobileMedium: mobileMedium,
      tabletSmall: tabletSmall,
      twoColumn: twoColumn
    },
    children: children
  });
};
OVContextProvider.propTypes = {
  children: PropTypes.node
};

var OVApp = function OVApp(_ref2) {
  var children = _ref2.children;
  var search = window.location.search;
  var urlParams = new URLSearchParams(search);
  var client = graphqlClient(urlParams);
  return /*#__PURE__*/_jsx(Provider, {
    value: client,
    children: /*#__PURE__*/_jsx(OVContextProvider, {
      children: children
    })
  });
};

OVApp.propTypes = {
  children: PropTypes.node
};
export default OVApp;